import { render, staticRenderFns } from "./TickerTape.vue?vue&type=template&id=9a2842d4&"
import script from "./TickerTape.vue?vue&type=script&lang=js&"
export * from "./TickerTape.vue?vue&type=script&lang=js&"
import style0 from "./TickerTape.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports